import { addVrLesson } from "api/services/vr-lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useAddVrLesson = () => {
    const { callAPI } = useWorkspaceApiCall(addVrLesson, 'addLesson.success', 'addLesson.error');

    return { addVrLesson: callAPI };
}
